<template>
	<h1>Page not found</h1>
</template>

<script>
export default {
	name: "error-404",
}
</script>